import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import {Styles} from '../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {Translate} from '../../../config/Translate';
import validator from 'validator';
import axios from 'axios';
import { defaultVariabls } from '../../../config/index';
import {setStore, getStore, connect} from "trim-redux";
import {Link, withRouter} from 'react-router-dom';
import { withSnackbar } from 'notistack';
import {secret} from "../../../config/Security";
import Box from "@material-ui/core/Box/Box";
import TextField from "@material-ui/core/TextField/TextField";
import LoadingButton from "../../components/elements/LoadingButton";
import HeaderTags from "../../components/elements/HeaderTags";
import AuthLayout from "../../components/layouts/AuthLayout";
import PassField from "../../components/fields/PassField";
import queryString from "query-string";
import Button from "@material-ui/core/Button/Button";
import Feature from "../../components/elements/Feature";
import Hidden from "@material-ui/core/Hidden/Hidden";
import ExitToAppRoundedIcon from '@material-ui/icons/ExitToAppRounded';
class Login extends React.Component {
    constructor(props){
        super(props);
        const values = queryString.parse(this.props.location.search)
        let redirect = values.r;
        if(!!redirect){
            if(this.props.isAuth) {
                this.handleLogout();
            }
        }else{
            if(this.props.isAuth){
                this.props.history.push("/");
            }
        }
        this.state={
            fields: {
                username:'',
                password:''
            },
            errors:{},
            SubmitLoading:false,
            success:false,
            anchorEl:null,
            redirect: !!redirect ? redirect : null
        };
    }
    handleLogout(){
        localStorage.removeItem('ACT');
        localStorage.removeItem('RET');
        setStore({
            isAuth : false,
            user : null,
        });
    }
    handleChange(e){
        let {fields,errors} = this.state;
        let target = e.target;
        errors[target.name] = "";
        fields[target.name] = target.value;
        this.setState({fields});
    }
    handleValidation(callback){
        let { fields } = this.state;
        let errors = {};
        let formIsValid = true;

        //Username
        if(validator.isEmpty(fields.username)){
            formIsValid = false;
            errors['username'] = Translate.emptyEmailOrMobile;
        }
        //Password
        if(validator.isEmpty(fields.password)){
            formIsValid = false;
            errors['password'] = Translate.emptyPassword;
        }
        this.setState({errors},() =>{
            if(!formIsValid){
                this.setState({
                    SubmitLoading:false
                })
            }
            return callback(formIsValid)
        });
    }
    async handleRequest(){

        const {username, password} = this.state.fields;

        let data = new FormData();
        data.append('secret', secret);
        data.append('username', username);
        data.append('password', password);
        let config = {
            headers: {
                Accept: 'application/json',
            }
        };
        await axios.post(`${defaultVariabls.url}/login`, data, config)
            .then(response =>{
                console.log(response.data)
                localStorage.setItem('ACT',response.data.accessToken);
            })
            .catch(error =>{
                console.log(error.response)
                this.setState({
                    SubmitLoading:false

                })
                this.props.enqueueSnackbar(Translate.loginError, {
                    variant: 'error',
                });
            });
        const loginToken = localStorage.getItem('ACT');
        if(loginToken !== null){
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            await axios.get(`${defaultVariabls.url}/checkLogin`, config)
                .then(response => {
                    setStore({
                        isAuth : true,
                        user : response.data,
                    });
                    this.setState({
                        SubmitLoading:false,
                        success:true
                    })
                }).catch(error => {
                    console.log(error.response)
                    setStore({
                        isAuth : false,
                        user : null,
                    });
                    this.setState({
                        SubmitLoading:false

                    })
                })
        }else {
            setStore({
                isAuth : false,
                user : null,
            });
            this.setState({
                SubmitLoading:false
            })
        }
        if (getStore().isAuth){
            let code = getStore().user.login_token;
            if(this.state.redirect){
                localStorage.setItem("external_redirect",this.state.redirect);
            }
            window.location.replace(`${defaultVariabls.website}/loginFromPanel/${username}/${code}`);
        }
    }
    handleSubmit(e){
        this.setState({
            SubmitLoading:true
        })
        e.preventDefault();
        this.handleValidation((valid) =>{
            if(valid) {
                this.handleRequest();
            }
        });
    }
    render() {
        const {classes} = this.props;
        const {errors,SubmitLoading,success} = this.state;
        return (
                <AuthLayout>
                    <HeaderTags title={Translate.login}/>

                    <Grid item xs={11} md={11} lg={10} >
                        <Box mb={{xs: 3, xl: 8}}  fontSize={18}>
                            <strong className={classes.auth_title}>
                                <ExitToAppRoundedIcon style={{marginLeft:10}} color="primary"/>
                                {Translate.login}
                                </strong>
                        </Box>

                        <form className={classes.form} noValidate onSubmit={this.handleSubmit.bind(this)}>
                            <Grid container spacing={0} justify="center" alignItems='center'>
                                <Grid item xs={12}>
                                    <TextField
                                        required
                                        fullWidth
                                        variant="outlined"
                                        id="username"
                                        label={Translate.emailOrMobile}
                                        placeholder={Translate.emailOrMobile}
                                        name="username"
                                        size="small"
                                        autoComplete="username"
                                        onChange={this.handleChange.bind(this)}
                                        autoFocus
                                        error = {!!errors['username']}
                                        helperText={errors['username']}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <PassField
                                        margin="normal"
                                        required
                                        variant="outlined"
                                        fullWidth
                                        size="small"
                                        name="password"
                                        label={Translate.password}
                                        placeholder={Translate.password}
                                        type="password"
                                        id="password"
                                        onChange={this.handleChange.bind(this)}
                                        autoComplete="current-password"
                                        error = {!!errors['password']}
                                        helperText={errors['password']}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <LoadingButton
                                        type="submit"
                                        size="large"
                                        variant="contained"
                                        color="secondary"
                                        style={{width:"100%"}}
                                        onClick = {this.handleSubmit.bind(this)}
                                        loading = {SubmitLoading}
                                        success = {success}
                                    >
                                        {Translate.login}
                                    </LoadingButton>
                                </Grid>
                                <Feature check="token_login">
                                    <Grid item xs={12}>
                                        <Button style={{width:'100%'}} component={Link} to="/token-login" color="primary" variant="outlined">
                                            <strong>
                                                {Translate.loginWithToken}
                                            </strong>
                                        </Button>
                                    </Grid>
                                </Feature>
                                <Grid item xs={6} md={6} style={{textAlign:"right",marginTop:15}}>
                                    <Typography>
                                        <Hidden xsDown>
                                        {Translate.dontHaveAccount}
                                        </Hidden>
                                        <Button size={"small"} component={Link} color="primary" to="/register">
                                            <strong>
                                                {Translate.doRegister}
                                            </strong>
                                        </Button>
                                    </Typography>
                                </Grid>
                                <Grid item xs={6} md={6} style={{textAlign:"left"}}>
                                    <Button size={"small"} component={Link} to="/forget" >
                                        {Translate.forgetPass}
                                    </Button>
                                </Grid>

                            </Grid>
                        </form>
                    </Grid>
                </AuthLayout>
        );

    }
}
const mstp = state => ({
    isAuth: state.isAuth,
    user: state.user
});
export default withSnackbar(withRouter(withStyles(Styles)(connect(mstp)(Login))));